import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var BedIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 30 28",
                    children: _jsx("path", {
                        d: "M25.002.667a3.334 3.334 0 013.326 3.114l.008.219v10.17c.549.907.919 2.02 1.1 3.328l.02.296.016.378.007.302.01.192V26a1.333 1.333 0 01-2.658.155L26.82 26v-1.335H3V26c0 .684-.515 1.247-1.178 1.324l-.155.01a1.334 1.334 0 01-1.325-1.179L.333 26v-7.334l.004-.05.002-.74c.157-1.692.605-3.084 1.328-4.142V4A3.334 3.334 0 014.78.674L5 .667h20.002zm1.82 18.666H3V22h23.821v-2.666zM6.623 14h16.198l.258.005c1.83.068 2.94.888 3.466 2.66H3.237C3.724 14.8 4.807 14 6.624 14zM25.002 3.333H5c-.327 0-.6.236-.656.547l-.01.12v7.69a6.456 6.456 0 011.41-.31 3.286 3.286 0 01-.069-.47l-.008-.244v-2.68A3.334 3.334 0 018.78 4.658L9 4.652h12a3.333 3.333 0 013.326 3.114l.007.22v2.68c0 .27-.032.532-.092.783.51.085.988.221 1.429.405L25.669 4c0-.327-.236-.6-.547-.656l-.12-.01zm-3.346 7.453a.667.667 0 01-.656.547H9l-.12-.01a.667.667 0 01-.547-.657v-2.68l.011-.12A.667.667 0 019 7.318h12l.12.01a.667.667 0 01.547.656v2.681l-.011.12z",
                        fillRule: "evenodd",
                        clipRule: "evenodd"
                    })
                })
            })
        ]
    });
};
BedIcon.isCarinaIcon = true;
export default BedIcon;
